/**
 * Resolve the color treatment (bg/fg/accent) for a given metric source key,
 * falling back from exact match → metric-name match → provider-prefix match → default.
 */
import { SOURCE_COLORS } from '../constants';
import { metricOf, providerOf } from './metric-keys';

export function getSourceColor(source: string) {
  if (SOURCE_COLORS[source]) return SOURCE_COLORS[source];
  // Try the metric name without provider prefix (e.g. "oura/restingHeartRate" → "restingHeartRate")
  const metric = metricOf(source);
  if (metric !== source && SOURCE_COLORS[metric]) return SOURCE_COLORS[metric];
  // Match by provider prefix (e.g. 'oura:unknown' → uses 'oura:sleep' colors)
  const provider = providerOf(source) || source.split(':')[0];
  const prefixKey = Object.keys(SOURCE_COLORS).find(k => k.startsWith(provider + ':'));
  if (prefixKey) return SOURCE_COLORS[prefixKey];
  return SOURCE_COLORS.default;
}
